import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw24px = 'M11.353 6.1V18H9.908v-5.559H4.213V18H2.768V6.1h1.445v5.134h5.695V6.1h1.445ZM19.668 18v-2.567h-5.695v-1.02L18.359 6.1h1.445l-4.301 8.16h4.182l.272-3.451 1.139-.017v3.468h1.666v1.173h-1.666V18h-1.428Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const TextH4Icon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'textH4'));
TextH4Icon.displayName = 'TextH4Icon';
TextH4Icon.propTypes = Icon.propTypes;
TextH4Icon.renderIcon = props => /*#__PURE__*/React.createElement(TextH4Icon, props);
export default TextH4Icon;
//# sourceMappingURL=TextH4Icon.js.map